import React from 'react';
import Header from './Header';
import Footer from './footer';
import './DetailAllergy.css';

const DetailAllergy = ({
  allergy,
  title,
  userLanguageBrowser,
  flagUrl,
  iconAssets,
  showRealImages,
  onClose,
  onPlaySound,
  getAllergyImageUrl
}) => {
  const handlePlayAllergen = () => {
    if (allergy?.audioUrl) {
      onPlaySound(allergy.audioUrl);
    }
  };

  if (!allergy) return null;

  return (
    <div className="detail-allergy-overlay">
      <div className="detail-allergy-container">
        {/* Header */}
        <Header
          title={title}
          leftIcon={iconAssets?.warning}
          rightIcon={flagUrl}
        />

        {/* Main content */}
        <div className="detail-allergy-content">
          <div className="detail-allergy-image-container">
            <img
              className="detail-allergy-image"
              src={getAllergyImageUrl(allergy)}
              alt={allergy.name}
            />
            {/* Red cross lines */}
            <div className="detail-cross-line line1"></div>
            <div className="detail-cross-line line2"></div>
          </div>

          <h1 className="detail-allergy-title">{allergy.translation}</h1>
          {userLanguageBrowser !== "en" && (
            <p className="detail-allergy-subtitle">{allergy.name}</p>
          )}
        </div>

        {/* Footer */}
        <Footer />

        {/* Action buttons */}
        <div className="detail-action-bar">
          <button
            className={`detail-action-btn ${!allergy?.audioUrl ? 'disabled' : ''}`}
            onClick={handlePlayAllergen}
            disabled={!allergy?.audioUrl}
          >
            {iconAssets?.speaker && (
              <img src={iconAssets.speaker} alt="Speaker" className="detail-action-icon" />
            )}
          </button>
          <button className="detail-action-btn close-btn" onClick={onClose}>
            <span className="close-icon">×</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailAllergy;
